//import FocusBlurByScroll from "@/pcomponents/common/crud/write/input_func/focus_blur_by_scroll";
class FocusBlurByScroll {
  static add_event = (inData: any) => {
    let opt_obj = {
      scroll_obj: null,
      ...inData
    };
    if (opt_obj.scroll_obj == null) {
      return false;
    }
    let this_obj = this;
    opt_obj.scroll_obj.addEventListener('scroll', () => {
      const el: any = document.activeElement;
      if (
        el &&
        (el.tagName === 'INPUT' ||
          el.tagName === 'TEXTAREA' ||
          el.isContentEditable)
      ) {
        if (this_obj.isOutOfView(el, opt_obj.scroll_obj)) {
          el.blur();
        }
      }
    });
  };
  static isOutOfView = (el: any, scroll_obj: any) => {
    if (scroll_obj == null) {
      return false;
    }
    const rect = el.getBoundingClientRect();

    return (
      rect.bottom < 0 ||
      rect.top > scroll_obj.offsetHeight
    );
  };
}
export default FocusBlurByScroll;